import { FormControl, MenuItem, Select } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { PortOrientation } from "~/api/portOrientation/portOrientation";
import { useAppSelector } from "~/app/store";
import { settingsSelectSx } from "~/features/settings/settings.styles";
import { selectUserIsAdmin } from "~/redux/selectors/authSelectors";
import { UpdateWorkstation } from "~/types/api";

export function WorkstationOrientationSelect() {
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const { register, watch } = useFormContext<UpdateWorkstation>();

  return (
    <FormControl fullWidth size="small">
      <Select
        variant="outlined"
        fullWidth
        disabled={!isAdmin}
        {...register("orientation")}
        value={watch("orientation")}
        sx={settingsSelectSx}
      >
        {Object.values(PortOrientation).map((orientation) => (
          <MenuItem key={orientation} value={orientation}>
            {orientation}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
